import { NewToggleListAbsoluteAdvancedHover } from '../components/inventory/new-toggle-list-absolute-advanced-hover.vue';
Vue.component('new-toggle-list-absolute-advanced-hover', NewToggleListAbsoluteAdvancedHover);